import PropTypes from "prop-types";

import "../../styles/DefineReportingPeriods.scss";

/**
 * Two inputs for defining periods as first semester, second semester, or neither.
 * @name DefineInputGroup
 * @param {bool} firstSemChecked
 * @param {string} firstSemContentKey
 * @param {number} firstSemTemplateContentId
 * @param {func} handleOnChange
 * @param {bool} isSecondSemester
 * @param {bool} reportFlag
 * @param {bool} secondSemChecked
 * @param {string} secondSemContentKey
 * @param {number} secondSemTemplateContentId
 * @param {bool} yearComplete
 * @returns {JSX.Element}
 */
const DefineInputGroup = ({
    firstSemChecked,
    firstSemContentKey,
    firstSemTemplateContentId,
    handleOnChange,
    isSecondSemester = false,
    reportFlag,
    secondSemChecked,
    secondSemContentKey,
    secondSemTemplateContentId,
    yearComplete
}) => {
    return reportFlag ? (
        <div className="standard-check-container">
            <label className="visually-hidden" htmlFor={firstSemTemplateContentId}>
                First Semester
            </label>
            <input
                aria-label="First Semester"
                checked={firstSemChecked}
                data-contentkey={firstSemContentKey}
                disabled={yearComplete || isSecondSemester}
                id={firstSemTemplateContentId}
                name={firstSemTemplateContentId}
                onChange={(e) => handleOnChange(e)}
                type="checkbox"
                value={firstSemChecked}
            />
            <label className="visually-hidden" htmlFor={secondSemTemplateContentId}>
                Second Semester
            </label>
            <input
                aria-label="Second Semester"
                checked={secondSemChecked}
                data-contentkey={secondSemContentKey}
                disabled={yearComplete}
                id={secondSemTemplateContentId}
                name={secondSemTemplateContentId}
                onChange={(e) => handleOnChange(e)}
                type="checkbox"
                value={secondSemChecked}
            />
        </div>
    ) : (
        <div className="standard-check-container">
            <div className="dash">&mdash;</div>
            <div className="dash">&mdash;</div>
        </div>
    );
};

DefineInputGroup.propTypes = {
    firstSemChecked: PropTypes.bool,
    firstSemContentKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    firstSemTemplateContentId: PropTypes.number,
    handleOnChange: PropTypes.func,
    isSecondSemester: PropTypes.bool,
    reportFlag: PropTypes.bool,
    secondSemChecked: PropTypes.bool,
    secondSemContentKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    secondSemTemplateContentId: PropTypes.number,
    yearComplete: PropTypes.bool
};

export default DefineInputGroup;
